export type Category = {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  tagline: string;
};

export function getCategory(slug: string): Category | undefined {
  return CATEGORIES.find((c) => c.slug === slug);
}

export const SITE_NAME = "吃瓜17";
export const SITE_SLOGAN = "今日新瓜速递 · 最新爆料一站看";
export const SITE_URL = "https://xttkax.cn";

export const CATEGORIES: Category[] = [
  {
    slug: "yingshi",
    name: "影视速递",
    icon: "ri-film-line",
    tagline: "剧集上新 · 档期看点",
    desc: "新剧热播、影片口碑、幕后创作，影视圈的最新动态都在这。",
  },
  {
    slug: "zongyi",
    name: "综艺现场",
    icon: "ri-camera-lens-line",
    tagline: "高能名场面 · 嘉宾互动",
    desc: "热门综艺首播与名场面盘点，带你围观每一期的高光时刻。",
  },
  {
    slug: "yinyue",
    name: "音乐现场",
    icon: "ri-mic-line",
    tagline: "新歌首唱 · 巡演资讯",
    desc: "新歌发布、现场舞台与巡演情报，听见华语乐坛的每一次新鲜。",
  },
  {
    slug: "mingxing",
    name: "明星动态",
    icon: "ri-star-line",
    tagline: "行程分享 · 红毯造型",
    desc: "艺人公开行程、红毯造型与作品动态，追星不掉线。",
  },
  {
    slug: "redian",
    name: "热点话题",
    icon: "ri-fire-line",
    tagline: "热搜复盘 · 全网热议",
    desc: "整理当下全网热议的话题与热梗，快速看懂大家在聊什么。",
  },
];

export const NAV_LINKS = [
  { to: "/", label: "今日首页" },
  { to: "/news", label: "资讯速递" },
  { to: "/hot", label: "热门话题" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "吃瓜指南" },
];